import * as v from "valibot";

export default function useSchemas() {
    const { t } = useI18n();

    const BomNameSchema = v.pipe(v.string(), v.trim(), v.nonEmpty(t("BOMTool.BOMNameRequired")));

    const BomQuantitySchema = v.pipe(
        v.string(),
        v.decimal("A number is required"),
        v.transform(Number),
        v.transform(Math.floor),
        v.minValue(1, "Value must be 1 or more")
    );

    return { BomNameSchema, BomQuantitySchema };
}
